// extracted by mini-css-extract-plugin
export default {"root":"bullet-point-item-module--root--c95ef","checkmark":"bullet-point-item-module--checkmark--21cd1","subText":"bullet-point-item-module--sub-text--e2e3b"};